/* eslint-disable no-unused-vars */
/* eslint-disable react/require-default-props */
import {
  instanceOf,
  number,
  oneOf,
  oneOfType,
  string,
  any,
  object,
  func,
} from "prop-types";

import styles from "./Text.styles";

/*
	Define all your text types here and add them to the typeShape.
	That way they are validated with the prop-type checker.
*/
const H1 = "H1";
const H2 = "H2";
const H3 = "H3";
const H4 = "H4";
const P1 = "P1";
const P2 = "P2";
const P3 = "P3";
const C1 = "C1";
const C2 = "C2";
const C3 = "C3";
const LT = "LT";

export const typeShape = oneOf([H1, H2, H3, H4, P1, P2, P3, C1, C2, C3, LT]);

const center = "center";
const left = "left";
const right = "right";

export const typeTextAlign = oneOf([center, left, right]);

export default function Text({
  children = "",
  as = P1,
  bold = false,
  style,
  mt,
  ta = left,
  ...restProps
}) {
  const styless = [
    styles.base,
    styles[as],
    styles[bold],
    { marginTop: mt, textAlign: ta },
    style,
  ];

  const flatObj = {
    ...styless.reduce((acc, curr) => {
      if (typeof curr === "object" && !Array.isArray(curr)) {
        return { ...acc, ...curr };
      }
      return acc;
    }, {}),
  };

  return (
    <div style={{ ...flatObj, ...style }} {...restProps}>
      {children}
    </div>
  );
}

Text.propTypes = {
  children: oneOfType([string, any]),
  as: typeShape,
  style: oneOfType([object, any, func]),
  bold: oneOfType([any, func]),
  mt: number,
  ta: typeTextAlign,
};
